import { PARTNER_LIST, GET_PARTNER } from '../../types/types';

export default ( state = {}, action: any) => {
  //console.log('reducer', state, action);
  switch( action.type ) {
    case PARTNER_LIST: 
      return { ...state, partnerList: action.payload };
    case GET_PARTNER:
      return { ...state };
    default:
      return state;
  }
}